<template>
  <footer>Copyright&nbsp;&copy;	&nbsp;<span><time v-text="copyRightYear"></time></span>&nbsp;上海荟医信息科技有限公司 All Rights Reserved. 沪ICP备16021696号</footer>
</template>

<script type="text/ecmascript-6">
export default {
  name:'Footer',
  data() {
    return {

    }
  },
  computed:{
      copyRightYear(){
          return new Date().getFullYear();
      }
  }
}
</script>

<style scoped lang="scss">
footer{
  font-size:16px;
  text-align: center;
  line-height: 60px;
}
</style>
